import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "card" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-header align--flex-start" }, null, -1)
const _hoisted_6 = { class: "card-content" }
const _hoisted_7 = { class: "row ma--bottom-1" }
const _hoisted_8 = { class: "col-xl-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "text--size-1-5" }, " Have a question or need support? ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", { class: "text--size-1 color--primary-gray text--weight-regular line--height-1-3" }, " Please submit your information and questions below and our support staff will get back to you within 48-72 hours. ", -1)
const _hoisted_11 = { class: "card-content" }
const _hoisted_12 = { class: "form-field__control" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: " ",
  class: "form-field__label"
}, "Name", -1)
const _hoisted_14 = { class: "form-field__control" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: " ",
  class: "form-field__label"
}, "Email", -1)
const _hoisted_16 = { class: "form-field__control" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "msg",
  class: "form-field__label"
}, "Enter Your Message Here...", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "card-actions display--flex justify--flex-start" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn--primary"
  }, " Submit ")
], -1)
const _hoisted_19 = { class: "col-xl-6" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "row ma--top-8" }
const _hoisted_22 = { class: "pa--y-1 pa--left-8" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "row ma--top-1" }
const _hoisted_26 = { class: "pa--y-1 pa--right-1" }
const _hoisted_27 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.request._loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("form", {
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.support && _ctx.support(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field form-field__standard ma--top-1", {
                            'form-field--is-invalid': _ctx.v$.request.name.$error,
                            'form-field--is-active': !_ctx.v$.request.name.$invalid,
                          }])
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-field__input",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.request.name) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.request.name],
                      [_directive_focus]
                    ])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field form-field__standard", {
                            'form-field--is-invalid': _ctx.v$.request.email.$error,
                            'form-field--is-active': !_ctx.v$.request.email.$invalid,
                          }])
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-field__input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.request.email) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.request.email],
                      [_directive_focus]
                    ])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field form-field__standard", {
                            'form-field--is-invalid': _ctx.v$.request.message.$error,
                            'form-field--is-active':
                              !_ctx.v$.request.message.$invalid,
                          }])
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _withDirectives((_openBlock(), _createElementBlock("textarea", {
                      rows: "8",
                      cols: "50",
                      id: "msg",
                      class: "form-field__input",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.request.message) = $event))
                    }, [
                      _createTextVNode("\r\n                            ")
                    ])), [
                      [_vModelText, _ctx.request.message],
                      [_directive_focus]
                    ])
                  ])
                ], 2)
              ]),
              _hoisted_18
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_ctx.isAerolead())
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("img", {
                        src: _ctx.supportLogo,
                        style: {"width":"70%","height":"70%"}
                      }, null, 8, _hoisted_23)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("img", {
                        src: _ctx.supportLogo,
                        style: {"width":"90%","height":"90%"}
                      }, null, 8, _hoisted_27)
                    ])
                  ])
                ]))
          ])
        ])
      ])
    ])
  ], 64))
}